var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service w"},[_c('Row',{staticClass:"component-title"},[_c('Col',{staticClass:"fs-225px",attrs:{"span":"24"}},[_vm._v("服务流程")])],1),_c('div',{staticClass:"process"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }